import {
    FETCH_PROJECT_DETAILS,
    FETCH_PROJECT_DETAILS_ERROR
} from '../actions/types'

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_PROJECT_DETAILS:
            return {
                ...state,
                [action.searchName]: action.payload
            }
        default:
            return state
    }
}